/* eslint-disable */
module.exports = {
  noInfo: value => {
    if (!value) return "";
    return value;
  }
};
